<template lang="pug">
.dialog-container(v-if="show", @touchmove.prevent)
  .dialog-info
    .dialog-close(@click="close")
      img(src="https://m.hellobike.com/resource/helloyun/08345/RgWuqOj-cJ.png?x-oss-process=image/quality,q_80")
    .dialog-block
    .dialog-sign(@click="goSign") 签到成功
  .shadow
  </template>
<script>
import { env } from '@hb/hbridge';
import { getVersion } from '@/utils/systemCode';
import { UBT } from '@hb/tianqi/lib/ubt.h5';

export default {
  components: {
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    userNewId: {
      type: Number,
      default: 0,
    },
    isSign: {
      type: Boolean,
      require: true,
    },
  },
  data() {
    return {
      env,
      version: '',
    };
  },
  watch: {
  },
  async created() {
    this.version = await getVersion();
  },
  mounted() {
  },
  destroyed() {
  },
  methods: {
    // showBtn() {
    //   if (!env.isEasyBikeApp) {
    //     return false;
    //   } if (env.isIOS && this.version < '6.65') {
    //     return false;
    //   }
    //   if (this.isSign) {
    //     return false;
    //   }
    //   return true;
    // },
    close() {
      this.$emit('update:show', false);
    },
    goSign() {
      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_qiandaochenggong',
        categoryId: 'platform',
        businessInfo: {},
      });
      this.$emit('update:show', false);
    },
  },
};
</script>

<style lang="less" scoped>
.dialog-container {
  .dialog-info {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 330;

    .dialog-close {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 0.2rem;

      img {
        width: 0.26rem;
        height: 0.26rem;
      }
    }


    .dialog-block {
      width: 3.04rem;
      height: 2.78rem;
      background-image: url(https://m.hellobike.com/resource/helloyun/22871/AnDGVXLWjb.png);
      background-size: 100% 100%;
      overflow: hidden;
    }

    .dialog-sign {
      width: 2.57rem;
      height: 0.54rem;
      margin: 0.24rem auto 0 auto;
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-weight: 500;
      font-size: 0.18rem;
      color: #fff;
      line-height: 0.54rem;
      text-align: center;
      border-radius: 0.29rem;
      border: 1px solid #998e83;
    }
  }

  .shadow {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 300;
  }
}
</style>
